import React from "react";
import "./circleText.scss";
import "../../../styles/fontSizes.scss";
import Text from "../../atoms/text/text";
//Necesita que el padre tenga positicionamiento relativo.
//Recibe el tipo de órbita, limitado a la implementación del estilo del componente dentro de su hoja de estilo
const CircleText = ({
  isOnFocus,
  className,
  bgColor,
  color,
  text,
  textSize,
  rotation,
}) => {
  return (
    <>
      <div
        style={{
          transform: `rotateZ(${rotation}Deg) scale(${isOnFocus ? "1.5" : 1})`,
          backgroundColor: bgColor,
        }}
        className={`${className} circle-text__container font-size--${textSize}`}
      >
        <Text color={color} type="h" textSize={textSize}>
          {text}
        </Text>
      </div>
    </>
  );
};

export default CircleText;
